module.exports = __webpack_public_path__ + "media/incineroar.1c5adfdb.wav";